import React, { useState } from 'react';
import Box from "@material-ui/core/Box";
import { Button, Container, createStyles, Grid, makeStyles, TextField, Theme } from "@material-ui/core";
import { connect } from "react-redux"
import { ApplicationState } from "../../redux/reducers";
import { ICliente } from '../../entities/catalogos/ICliente';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Add, Delete } from '@material-ui/icons';
import useCommonApi from '../../api/useCommonApi';
import { IUsuario } from '../../entities/catalogos/IUsuario';
import { IEvent } from '../../interfaces/IEvent';
import ReferenciaNumberField from '../controls/ReferenciaNumberField';
import { useSnackbar } from 'notistack';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';



const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        principal: {
            height: '100%',
            backgroundColor: "#fff",
            margin: "0px",
            padding: "0 0 20px 0",
        },
        button: {

            backgroundColor: "#00653b",
            color: "#fff"
        },
        table: {
            paddingTop: "50px",
            minHeight: "220px"
        },
        tr: {
            fontWeight: 600
        },
        filters: {
            backgroundColor: "#ececec",
            boxShadow: "none",
            verticalAlign: "middle",
            padding: "10px"
        },
        label: {
            fontSize: '12px',
            fontWeight: 600,
            marginTop: "10px"
        },
        textField: {
            backgroundColor: "#fff"
        },
        icon: {
            width: "30px",
            height: "30px",
            minWidth: "30px",
            borderRadius: "15px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "right",

        },
        marginButton: {
            margin: "10px 0px 0 30px"
        }
    }),
);


interface StateProps {
    cliente: ICliente
    usuario: IUsuario
}

interface DispatchProps {

}

interface OwnProps {
    setReferencias: (referencias: any) => void
    referencias: any
}

type Props = StateProps & DispatchProps & OwnProps

const Referencias = (props: Props) => {
    const classes = useStyles();
    const [referencias, setReferencias] = useState<any[]>(props.referencias != null ? props.referencias : []);
    const [referenciasCliente, setReferenciasCliente] = useState<any[]>([]);
    const apiSource = useCommonApi();
    const [referenciaAdicional, setReferenciaAdicional] = useState('');
    const [refs, setRefs] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    React.useEffect(() => {
        if (props.referencias.length === 0) {
            buscarReferenciasCliente();
        }
    }, []);

    const buscarReferenciasCliente = () => {
        setLoading(true);
        getReferenciasCliente().then(dataCliente => {
            setReferenciasCliente(dataCliente);
            if (dataCliente != null && dataCliente.length) {
                let refs: any[] = [];

                dataCliente.forEach((s, i) => {
                    let ref = {
                        tipo: s.tipoDato.nombre,
                        tipoNumerico: s.tipoDato.nombre.charAt(0) + s.longitud,
                        longitud: s.longitud,
                        descripcion: s.descripcion,
                        pattern: s.tipoDato.nombre === 'ALFANUMÉRICO' ? '[A-Za-z]{0,9}' : s.tipoDato.nombre === 'NUMÉRICO' ? '[0,9]' : '[A-Za-z]',
                        clienteID: s.clienteID,
                        clienteReferenciaID: s.clienteReferenciaID,
                        index: i
                    };
                    refs.push(ref);
                });
                setReferencias(refs);
            }
            else {
                setReferencias([]);
            }
            setLoading(false);
        }).catch(error => {
        });
    }

    const getReferenciasCliente = async () => {
        const result = await apiSource.obtenerAsync<any>("cliente-referencia/by-id/" + props.cliente.id);
        return result;
    };

    const getReferenciaAdicional = () => {
        let adic;
        if (refs.length)
            adic = referenciasCliente.filter(s => (s.descripcion === traducirLabel(259)));
        else
            adic = referenciasCliente;
        return adic;
    }

    const nuevaReferencia = () => {
        const index = Math.max(...referencias.map(e => e.index), 0) + 1;

        let ref = {
            solicitudServicioID: 1,
            solicitudClienteReferenciaID: getReferenciaAdicional().length ? getReferenciaAdicional()[0]['clienteReferenciaID'] : 0,
            clienteID: props.cliente.id,
            clienteReferenciaID: 0,
            descripcion: traducirLabel(259),
            valor: referenciaAdicional,
            tipo: 'ALFANUMÉRICO',
            tipoNumerico: 'A25',
            longitud: 25,
            auditUsuarioID: props.usuario.id,
            index
        };

        referencias.push(ref);
        setReferenciaAdicional('');
    }

    const eliminarReferencia = (row) => {
        let referenciasFilter = referencias.filter(function (ref) {
            return ref.index !== row.index
        });

        setRefs(referenciasFilter);
        setReferencias(referenciasFilter);
    }

    const handleChange = (event: any | IEvent, row: any, index: number) => {
        let referenciaValue = event.target.value;

        if (row.tipo === 'TEXTO' && event.target.value !== '') {
            referenciaValue = referenciaValue.replace(/[^A-Za-z]/gi, "");
        }

        const copiaReferencia = {
            tipo: row.tipo,
            tipoNumerico: row.tipoNumerico,
            descripcion: row.descripcion,
            longitud: row.longitud,
            clienteID: row.clienteID,
            clienteReferenciaID: row.clienteReferenciaID,
            valor: referenciaValue.toString(),
            index: row.index
        };

        setReferencias(referencias.map(m => m.index !== row.index ? m : copiaReferencia));
    }

    const setReferenciaSolicitud = () => {
        if (referencias.some(e => !e.valor)) {
            let mensaje = traducirMessage(102); // 'Favor de completar o eliminar las referencias sin valor';
            enqueueSnackbar(mensaje, { variant: "error" });
            return;
        }

        props.setReferencias(referencias);
    }

    return (<>
        <Container maxWidth="xl" className={classes.filters} >

            <Grid container  >
                <Grid item xs={1} >
                    <div className={classes.label}>
                        {/* Referencia */traducirLabel(258)}
                    </div>
                </Grid>

                <Grid item xs={8}>
                    {!loading &&
                        <form className={classes.root} noValidate autoComplete="off">
                            <TextField id="outlined-basic" size="small" className={classes.textField}
                                value={referenciaAdicional}
                                onChange={e =>
                                    setReferenciaAdicional(e.target.value as string)
                                }
                                inputProps={{
                                    maxLength: 25,
                                    pattern: "[a-z]{0,9}"
                                }}
                                variant="outlined" fullWidth
                            />
                        </form>
                    }
                </Grid>
                <Grid item xs={2} className={classes.marginButton} >
                    <Button className={classes.icon} variant="contained" color="primary" disabled={!referenciaAdicional} onClick={() => nuevaReferencia()}>
                        <Add />
                    </Button>
                </Grid>
            </Grid>
        </Container>

        <Container maxWidth="xl" className={classes.table}>
            <TableContainer >
                <Table aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tr}>
                                {/* DESCRIPCIÓN */traducirLabel(81)}
                            </TableCell>
                            <TableCell className={classes.tr}>
                                {/* REFERENCIA */traducirLabel(258)}
                            </TableCell>
                            <TableCell className={classes.tr}>
                                {/* TIPO */traducirLabel(296)}
                            </TableCell>
                            <TableCell className={classes.tr} />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!loading && referencias.map((row, i) => (
                            <TableRow key={row.index}>
                                <TableCell component="td" scope="row">
                                    {row.descripcion}
                                </TableCell>
                                <TableCell component="td" scope="row">
                                    {row.tipo === 'NUMÉRICO' &&
                                        <TextField id="outlined-basic" size="small"
                                            value={row.valor}
                                            required={row.clienteReferenciaID > 0}
                                            onChange={(e) => handleChange(e, row, i)}
                                            InputProps={{
                                                inputComponent: ReferenciaNumberField as any,
                                            }}
                                            inputProps={{
                                                maxLength: row.longitud > 0 ? row.longitud : 50,
                                            }}
                                            variant="outlined" fullWidth
                                        />
                                    }

                                    {row.tipo !== 'NUMÉRICO' &&
                                        <TextField id="outlined-basic" size="small" key={row.index}
                                            value={row.valor}
                                            onChange={(e) => handleChange(e, row, i)}
                                            inputProps={{
                                                maxLength: row.longitud > 0 ? row.longitud : 50,
                                                pattern: row.tipo === 'ALFANUMÉRICO' ? '[A-Za-z0-9]+' : '[A-Za-z]+'
                                                // pattern: row.pattern
                                            }}
                                            variant="outlined" fullWidth
                                        />
                                    }
                                </TableCell>
                                <TableCell component="td" scope="row">
                                    {row.tipoNumerico}
                                </TableCell>
                                <TableCell component="td" scope="row">
                                    {/*{row.clienteReferenciaID === 0 &&*/}
                                    <Button className={classes.icon} variant="contained" color="primary"
                                        onClick={() => eliminarReferencia(row)}>
                                        <Delete />
                                    </Button>
                                    {/*}*/}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </Container>
        <Container maxWidth="xl" >
            <Box display="flex" justifyContent="flex-end" mt={2}>
                <Box>
                    <Button variant="contained" color="primary" onClick={setReferenciaSolicitud}>
                        {/* Siguiente */traducirButton(15)}
                    </Button>
                </Box>
            </Box>
        </Container>
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    usuario: state.usuario
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(Referencias);
